import { createEnum } from "@redotech/zod/zod-enum";

/**
 * Canonical tracker statuses from external providers.
 *
 * EasyPost-aligned, using snake_case to match industry standard.
 * All tracking providers (EasyPost, Track123, FirstMile) map to these statuses.
 */
export enum TrackerStatus {
  UNKNOWN = "unknown",
  PRE_TRANSIT = "pre_transit",
  IN_TRANSIT = "in_transit",
  OUT_FOR_DELIVERY = "out_for_delivery",
  AVAILABLE_FOR_PICKUP = "available_for_pickup",
  DELIVERED = "delivered",
  RETURN_TO_SENDER = "return_to_sender",
  FAILURE = "failure",
  CANCELLED = "cancelled",
  ERROR = "error",
}

export const trackerStatusSchema = createEnum(TrackerStatus);
